// extracted by mini-css-extract-plugin
export default {"button":"PatientMergeBanner_button__QNSHV"};